import React from 'react';

export const  Preferences = ()=>  {
  return(
    <h2>Preferences</h2>
  );
}